import { auth } from '../config/firebase';
import type { NotificationPreferences } from '@researcher/shared';
import { apiUrl } from '../config/api';

async function getHeaders(): Promise<HeadersInit> {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

export async function registerFcmToken(token: string, platform: 'web' | 'ios' | 'android'): Promise<void> {
  const headers = await getHeaders();
  const response = await fetch(apiUrl('/notifications/token'), {
    method: 'POST',
    headers,
    body: JSON.stringify({ token, platform }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to register token');
  }
}

export async function unregisterFcmToken(token: string): Promise<void> {
  const headers = await getHeaders();
  const response = await fetch(apiUrl('/notifications/token'), {
    method: 'DELETE',
    headers,
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to unregister token');
  }
}

export async function getPreferences(): Promise<NotificationPreferences> {
  const headers = await getHeaders();
  const response = await fetch(apiUrl('/notifications/preferences'), { headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to get preferences');
  }

  return data.data;
}

export async function updatePreferences(
  preferences: Partial<NotificationPreferences>
): Promise<void> {
  const headers = await getHeaders();
  const response = await fetch(apiUrl('/notifications/preferences'), {
    method: 'PUT',
    headers,
    body: JSON.stringify(preferences),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to update preferences');
  }
}

export async function sendHeartbeat(): Promise<void> {
  try {
    const headers = await getHeaders();
    await fetch(apiUrl('/notifications/heartbeat'), {
      method: 'POST',
      headers,
    });
  } catch {
    // Heartbeat is best-effort, don't throw
  }
}
